module.exports = __webpack_public_path__ + "static/media/landing-results.90b36279.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/landing-results.png
// module id = 580
// module chunks = 0